/* istanbul ignore file */

export { ArticleFooterSection as default } from "./ArticleFooterSection";
